import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateSLARequestDto,
  CreateSLAResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

type UseCreateSLAOptions = {
  onError?: (error: ExtendedAxiosError) => void;
  onSuccess?: (data: CreateSLAResponseDto) => void;
};

export function useCreateSLA(options: UseCreateSLAOptions) {
  const { onError, onSuccess } = options;
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    CreateSLAResponseDto,
    ExtendedAxiosError,
    CreateSLARequestDto
  >({
    mutationKey: ['sla'],
    mutationFn: (r) => api.slasApi.createSLA(r).then((r) => r.data),
    onError,
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ['slas'],
      });
      onSuccess?.(data);
    },
  });
}
